<template>
  <div>
    <div class="headerSection">
      <v-row no-gutters>
        <v-col cols="10" class="">
          <div class="d-flex flex-row">
            <div class="d-flex flex-column justify-center">
              <img
                @click="handleBack"
                src="@/assets/newPreSession/mobileRightArrow.png"
                alt=""
                class="backIcon"
                :style="{'transform' : !$vuetify.rtl ? 'rotate(180deg)' : '' }"

              />
            </div>

            <div class="d-flex flex-column justify-center body-large-18-medium">
              {{ currentStep === 1 ? $t("newPreSession.stepOneTitle") : $t("newPreSession.stepTwoTitle") }}
            </div>
          </div>
          <div class="body-medium-16-regular mt-2">
            {{
              currentStep === 1
                  ? $t("newPreSession.stepOneSubtitle")
                  : $t("newPreSession.stepTwoSubtitle")
            }}
          </div>
        </v-col>
        <v-col cols="2">
          <v-progress-circular
            :value="progress"
            size="62"
            width="7"
            color="#39C990"
            rotate="-90"
          >
            <div v-if="$vuetify.rtl" class="body-medium-16-medium" style="color: #424242">
              {{ totalSteps }}/ {{ currentStep }}
            </div>
            <div v-else class="body-medium-16-medium" style="color: #424242">
              {{ currentStep }}/ {{ totalSteps }}
            </div>
          </v-progress-circular>
        </v-col>
      </v-row>
      <div class="promotionalView">
        <img
          v-if="currentStep === 1"
          src="@/assets/newPreSession/sleeveWhite.png"
          alt=""
          :class="$vuetify.rtl ? 'sleeve' : 'sleeveLtr'"

        />

        <img
          v-if="currentStep !== 1"
          src="@/assets/newPreSession/satisfyWithBackground.png"
          alt=""
          :class="$vuetify.rtl ? 'sleeve' : 'sleeveLtr'"
        />

        <div style="color: #035184" class="body-small-14-medium">
          {{
            currentStep === 1
                ? $t("newPreSession.promoStepOne")
                : $t("newPreSession.promoStepTwo")
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleBack() {
      this.$emit("go-back");
    },
  },

  props: {
    currentStep: {
      type: Number,
    },
  },
  data() {
    return {
      totalSteps: 3,
    };
  },
  computed: {
    progress() {
      return (this.currentStep / this.totalSteps) * 100;
    },
  },
};
</script>

<style scoped>
.headerSection {
  padding: 10px 24px;
  background-color: white;
}

.backIcon {
  width: 24px;
  height: 24px;
  align-self: center;
  margin-left: 4px;
}
.promotionalView {
  height: 34px;
  display: inline-flex; /* ✅ Not just flex */

  border-radius: 27px;
  background-color: #c5effe;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 8px;
  padding: 0 6px 0 13px;
}

.sleeve {
  width: 22px;
  height: 22px;
  margin-left: 4px;
}

.sleeveLtr {
  width: 22px;
  height: 22px;
  margin-right: 4px;
}
</style>
